/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-09 14:56:57
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-25 11:25:12
 */
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import ElementUI from "element-ui";
import VueResize from "vue-resize";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Auth from "./utils/Auth";
import API from "@/api/opinion";
import APIHot from "@/api/hotCenter";
import {
    Swiper as SwiperClass,
    Pagination,
    Mousewheel,
    Autoplay
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.css";
import "swiper/swiper.scss";
import "vue-resize/dist/vue-resize.css";

import "normalize.css/normalize.css";
import "@/assets/scss/element-variables.scss";
import "@/assets/iconfont/iconfont.css";
import "@/assets/scss/index.scss";
import "@/assets/iconfont/iconfont";

import Util from "@/utils/common";

// 公共组件注册
import YtPageHeader from "@/components/yt-page-header";
import YtCard from "@/components/yt-card";
import YtBlankCard from "@/components/yt-blank-card";
import YtTabsCard from "@/components/yt-tabs-card";
import YtTooltip from "@/components/yt-tooltip";
import EmptyBox from "@/components/empty-box";
import YtLoading from "@/components/yt-loading";

// 过滤器
import filters from "@/filter/filter.js";

import Api from "@/api/common.js";

// 自定义指令
import "@/directives/index.js";
Vue.use(VueCompositionAPI);
SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.component("YtPageHeader", YtPageHeader);
Vue.component("YtCard", YtCard);
Vue.component("YtBlankCard", YtBlankCard);
Vue.component("YtTabsCard", YtTabsCard);
Vue.component("YtTooltip", YtTooltip);
Vue.component("EmptyBox", EmptyBox);
Vue.component("YtLoading", YtLoading);
Vue.component("Swiper", Swiper);
Vue.component("SwiperSlide", SwiperSlide);
Vue.use(ElementUI);
Vue.use(VueResize);

Vue.config.productionTip = false;

// 手机收藏界面自动登录 (如果 cookie 内 有值， 并且 yt_h5_path 存在 则直接跳转 yt_h5_path)
const { from ,noLogin} = Util.parseUrl(window.location.href);
const h5_path = from || store.state.common.yt_h5_path;

const h5_cookie = Util.getCookie("ytdc_cookit");

console.log("!!!!!!!!!path", h5_path);
console.log("!!!!!!!!!cookie: ", h5_cookie);

// if (h5_cookie) {
//
//      window.location='http://mytdc.cricbigdata.com';
//     if (h5_path) {
//         window.open('http://mytdc.cricbigdata.com/');
//     } else {
//         window.open('http://mytdc.cricbigdata.com/');
//     }
// }

if (localStorage.getItem("yt-dc-token") || Auth.isLogin()) {
    // 每次进入网站都调用一次获取用户信息接口
    store.dispatch("common/fetchUserInfo");
}

router.beforeResolve((to, from, next) => {
    const lastPath = JSON.parse(sessionStorage.getItem("yt_last_path"));

    if (!lastPath && to.path !== "/search") {
        store.commit("common/updateDeactiveRoute", to.path);
        next();
    } else {
        if (from.path === to.path && to.path === "/search") {
            next();
        } else {
            // 处理页面刷新导致记录来源丢失问题
            if (from.path === "/" && lastPath !== from.path) {
                if (
                    from.path !== "/search" &&
                    lastPath !== "/account/accountDetail"
                ) {
                    store.commit("common/updateDeactiveRoute", lastPath);
                }
            } else {
                let _path = from.path;
                if (_path === "/search") {
                    _path = to.path;
                }

                if (_path === "/search") {
                    _path = lastPath;
                }
                store.commit("common/updateDeactiveRoute", _path);
            }
            store.commit("common/updateActiveRoute", to.path);
            next();
        }
    }
});

// h5/* 路径页面适配
function initH5() {
    const html = document.querySelector("html");
    if (window.location.pathname.includes("/h5")) {
        html.style.fontSize = "26.67vw";
        if (document.defaultView.innerWidth > 750) {
            html.style.fontSize = "13.34vw";
        }
        html.style.minWidth = "375px";
        html.style.maxWidth = "750px";
        html.style.margin = "0 auto";
    } else {
        html.style.fontSize = "";
    }
}

// router.beforeEach(async (to, from, next) => {
//     const token = localStorage.getItem("yt-dc-token");
//     const userInfo = JSON.parse(localStorage.getItem("yt_user"));

//     // 处理h5跳转带token进入购买页面
//     if (to.path.includes("h5/buy")) {
//         const token = to.query.token;
//         const buyFrom = to.query.from;
//         if (token) {
//             localStorage.setItem("yt-dc-token", decodeURIComponent(token));
//             // if (buyFrom && URL_RGE.test(buyFrom)) {
//             if (buyFrom) {
//                 localStorage.setItem("yt-dc-buy-from", buyFrom);
//             }
//             next();
//         } else {
//             if (
//                 /Android|webOS|iPhone|iPod|BlackBerry/i.test(
//                     navigator.userAgent
//                 )
//             ) {
//                 next("/h5/login");
//             }
//         }
//     } else if (to.path.includes("/h5")) {
//         next();
//     } else if (
//         /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
//     ) {
//         next("/h5/login");
//     } else if (token || Auth.isLogin()) {
//         const { iRemindType } = userInfo.aInfoData || {};
//         if (iRemindType === 3) {
//             store.commit("common/updateTriggerVipValidate", true);
//             next();
//         } else {
//             if (to.path === "/home") {
//                 await homeKeywordResolve(to, next);
//                 next();
//             } else {
//                 next();
//             }
//         }
//     } else {
//         if (to.fullPath.includes("/main/index")) {
//             next();
//         } else {
//             const noPermissionPages = [
//                 "/home",
//                 "/opinion",
//                 "/opinion/detail",
//                 "/hot/index",
//                 "/hot/policyArticleList",
//                 "/hot/hotArticleList",
//                 "/hot/policyDetail",
//                 "/top/index",
//                 "/dcLogin"
//             ];
//             if (noPermissionPages.includes(to.path)) {
//                 if (to.path === "/home") {
//                     await homeKeywordResolve(to, next);
//                     next();
//                 } else {
//                     next();
//                 }
//             } else {
//                 next("/main/index?type=login");
//             }
//         }
//     }
// });
// 主页根据 `keyword` 快速跳转
async function homeKeywordResolve(to, next) {
    const { keyword } = to.query;
    if (keyword) {
        if (keyword.includes("舆情")) {
            const { data } = await API.getOpinionKeyword({ sKeyWord: keyword });
            if (data.ErrorCode === 200) {
                if (data.Data.length === 0) {
                    next("/opinion");
                } else {
                    next(`/opinion/detail?name=${data.Data[0].label}`);
                }
            }
        } else if (keyword.includes("政策")) {
            const { data } = await APIHot.getHotKeyword({ sKeyWord: keyword });
            if (data.ErrorCode === 200) {
                if (data.Data.length === 0) {
                    next("/hot/policyArticleList");
                } else {
                    next(`/hot/policyArticleList?city=${data.Data[0].label}`);
                }
            }
        } else if (keyword.includes("资讯")) {
            next("/hot/hotArticleList");
        } else if (keyword.includes("公众号") || keyword.includes("微信")) {
            next("/top/index");
        } else {
            next();
        }
    }
}

// 路由拦截
router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem("yt-dc-token");

    if (token) {
        console.log('11111111',token)
        if (to.path === '/dcLogin') {
            localStorage.removeItem('yt-dc-token');
            next();
        } else {
            next()
        }
    } else {
        console.log('2222222222')
        next();
    }
});

// 百度统计
router.afterEach((to, from, next) => {
    initH5();
    // 线上环境
    if (process.env.NODE_ENV === "production") {
        if (to.path) {
            if (window._hmt) {
                window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
            }
        }
    }

    // 有token时push浏览日志
    localStorage.getItem("yt-dc-token") && Api.getYuntuLog({ sPath: to.path });
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
